import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'
import Icon from '../../../../../atoms/Icon'
import { ICON_NAMES } from '../../../../../../constants'
import TintedPill from './TintedPill'

const URGENT_COLOR = 'var(--color-decline-500)'

function UrgentBadge ({ reason }) {
  const content = (
    <TintedPill color={URGENT_COLOR} opacity={0.15}>
      <Icon name={ICON_NAMES.warning} customSize={12} color={URGENT_COLOR} />
      <span className='font-size-xs font-medium' style={{ color: URGENT_COLOR }}>Urgent</span>
    </TintedPill>
  )

  if (!reason) return content
  return <Tooltip title={reason} placement='top'>{content}</Tooltip>
}

UrgentBadge.propTypes = {
  reason: PropTypes.string
}

export default UrgentBadge
